import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useUserContext } from '../../contexts/UserContext';
import { apiShareImage } from '../../helpers/api';
import { successToast } from '../../helpers/toastHelper';
import { history } from '../../history';
import { gamifyBoardingActions, selectShareImageModal } from '../../redux/slicers/gamifySlicer';
import { InviteViaEmailUI } from '../admin/curator/RenderPreviewsDialog/InviteModal';
import Dialog from '../dialog/dialog';
import Heading from '../heading';
import "./steps.scss";
import { Mixpanel, MxEvent } from '../../common/Mixpanel';
import { selectUserPlanList } from "../../redux/slicers/subscriptionSlicer";

const initialErrorState = {
  emails: '',
};

export default function ShareImage({ image = '' }) {
  const dispatch = useDispatch();
  const { currentUser, isFreemiumUser , isPremiumUser } = useUserContext();
  const isShareImageModalOpen = useSelector(selectShareImageModal);
  const [emails, setEmails] = useState('');
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const getUserPlans = useSelector(selectUserPlanList);
  const isOldPremiumUser = isPremiumUser() && getUserPlans?.length === 0;

  useEffect(() => {
    resetStates();
  }, []);

  const resetStates = () => {
    setErrors(initialErrorState);
    setEmails('');
    setLoading(false);
  };

  const handleShareImage = () => {
    setLoading(true);
    const formData = new FormData();
    emails.forEach((email) => formData.append('email', email.name));
    const other_info = currentUser?.user?.other_info;
    const data = other_info?.gamifyOnBoarding?.data;
    const { tutorial_room_id, room_id } = data;
    const product = data?.selectedOnboardingProduct;
    const material = data?.selectedOnboardingMaterial;
    const wall_material = data?.selectedOnboardingOtherMaterial;
    const emailed_users = emails.map(email => email.name);
    Mixpanel.track( true, MxEvent.GAMIFY_ONBOARDING_IMAGE_SHARED,{
      "Tutorial room id": tutorial_room_id,
      "Room id": room_id,
      "Emailed users": emailed_users,
      "Product used id": product?.id,
      "Product used name": product?.name,
      "Material used id": material?.id,
      "Material used name": material?.name,
      "Wall/Floor Material used id": wall_material?.id,
      "Wall/Floor Material used name": wall_material?.name,
    })
    formData.append('room', room_id);
    formData.append('tutorialroom', tutorial_room_id);
    formData.append('product', product?.id);
    formData.append('material', material?.mainId);
    formData.append('other_object_material', wall_material?.mainId);
    apiShareImage(formData)
      .then((res) => {
        if (res && res?.status) {
          successToast(isOldPremiumUser ? '' :'We’ve added extra credits to your account.', 'Your image was shared!');
          dispatch(gamifyBoardingActions.closeShareImageModal());
          dispatch(gamifyBoardingActions.showAppFeedback());
          resetStates();
        }
      })
      .catch((error) => {
        setErrors({
          emails:
            !error?.status && error?.message
              ? error?.message
              : 'Something went wrong. Please try again.',
        });
      })
      .finally(() => setLoading(false));
  };

  const title = isFreemiumUser() ? (
    <>
      Share your image
      <br />
      and gain 5 extra credits.
    </>
  ) : (
    'Let’s share your 1st image.'
  );
  const description = isFreemiumUser()
    ? 'You can use your credits to remove watermark from the images.'
    : 'You can share your image with friends or colleagues, so they too can produce image & much more on imagine.io.';

  const closeModal = () => {
    console.log("mx: ","Did not share")
    dispatch(gamifyBoardingActions.closeShareImageModal());
    const params = new URLSearchParams(window.location.search);
    params.delete('isOnboarding');
    history.replace({
      search: params.toString(),
    });
    dispatch(gamifyBoardingActions.showAppFeedback());
  };

  if (!image || !isShareImageModalOpen) return null;

  return (
    <Dialog onHide={closeModal} size="lg">
      <div className="step step-0 d-flex overflow-hidden" style={{ borderRadius: '0.5rem' }}>
        <Col xs="6" style={{ padding: '113px 40px' }}>
          <figure
            style={{
              margin: 0,
              padding: 8,
              minHeight: 232,
              maxHeight: 235,
              borderRadius: 5,
              background: '#222327',
            }}>
            <img
              src={image}
              style={{
                display: 'block',
                margin: '0 auto',
                maxHeight: 216,
                borderRadius: 5,
              }}
              className="img-fluid"
            />
          </figure>
        </Col>
        <Col
          xs="6"
          className="d-flex justify-content-center position-relative"
          style={{ backgroundColor: '#1D1D1D', padding: '96px 32px 32px' }}>
          <div className="step-title">
            <Heading type="h2" style={{ fontWeight: 700 }}>
              <Col
                style={{
                  color: 'var(--white-color)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                {title}
              </Col>{' '}
            </Heading>
            <div className="step-text mb-3" style={{ color: '#B4B4B4' }}>
              {description}
            </div>
            <InviteViaEmailUI
              emails={emails}
              errors={errors}
              setEmails={setEmails}
              setErrors={setErrors}
              onSubmit={handleShareImage}
              loading={loading}
              labelColor={"#B4B4B4"}
              buttonTitle={'Share'}
              buttonClassName="w-25 shareImageBtn"
              btnFullWidth={false}
              buttonStyle={{
                display: 'block',
                margin: 'auto 0 0 auto',
                width: 105,
              }}
              customTagsStyle={{
                maxHeight: 100,
                overflow: 'auto'
              }}
            />
          </div>
        </Col>
      </div>
    </Dialog>
  );
}
